import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { login } from '../api/auth'
import request from '../api/request'

// 异步登录
export const loginAsync = createAsyncThunk(
  'user/login',
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await login({ username, password })
      // 服务器返回格式通常是 { access_token, user_info, ... }
      return {
        token: response.access_token,
        userInfo: response.user_info
      }
    } catch (error) {
      const errorMsg = error.response?.data?.detail
        || error.response?.data?.error
        || error.response?.data?.message
        || error.message
        || '登录失败';
      return rejectWithValue(errorMsg)
    }
  }
)

// 获取用户信息
export const fetchUserInfo = createAsyncThunk(
  'user/fetchUserInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await request.get('/auth/me/')
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || '获取信息失败')
    }
  }
)

const initialState = {
  isAuthenticated: false,
  token: null,
  userInfo: null,
  loading: false,
  error: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload
      state.isAuthenticated = true
      state.token = action.payload.token
      localStorage.setItem('token', action.payload.token)
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.userInfo = null
      state.token = null
      localStorage.removeItem('token')
    },
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.loading = false
        state.isAuthenticated = true
        state.userInfo = action.payload.userInfo
        state.token = action.payload.token
        localStorage.setItem('token', action.payload.token)
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(fetchUserInfo.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.loading = false
        state.userInfo = action.payload
        state.isAuthenticated = true
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { setUserInfo, logout, clearError } = userSlice.actions
export default userSlice.reducer
